import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import ScrollToTop from './components/ScrollToTop';
import FloatingContact from './components/FloatingContact';
import MetaVirtualAssistant from './pages/MetaVirtualAssistant';
import MarketingClientAcquisition from './pages/MarketingClientAcquisition';
import GrowthVisibility from './pages/GrowthVisibility';
import DigitalPlatformsExperience from './pages/DigitalPlatformsExperience';
import CreativeMediaBranding from './pages/CreativeMediaBranding';
import SystemsAutomationConsulting from './pages/SystemsAutomationConsulting';
import PatientCommunicationAnalytics from './pages/PatientCommunicationAnalytics';
import SocialMediaBranding from "./pages/SocialMediaBranding";
import Portfolio from './pages/Portfolio';
import Blog from './pages/Blog';
import Hiring from './pages/Hiring';
import WhatWeDo from './pages/WhatWeDo';
import OurTeam from './pages/OurTeam';

// Existing Blog Detail Pages
import LocalSEOGuide from './pages/LocalSEOGuide';
import SocialMediaStrategies from './pages/SocialMediaStrategies';
import GoogleAdsGuide from './pages/GoogleAdsGuide';

// New Blog Detail Pages - 9 Additional Routes
import SEOContentStrategy from './pages/SEOContentStrategy';
import InstagramMarketing from './pages/InstagramMarketing';
import EmailMarketing from './pages/EmailMarketing';
import PatientAcquisition from './pages/PatientAcquisition';
import WebsiteConversion from './pages/WebsiteConversion';
import AIAutomation from './pages/AIAutomation';
import TelemedicineMarketing from './pages/TelemedicineMarketing';
import MedicalWebsiteFeatures from './pages/MedicalWebsiteFeatures';
import HealthcareContentMarketing from './pages/HealthcareContentMarketing';

// External Redirect Component for Reviews
const ExternalRedirect = ({ to }) => {
  React.useEffect(() => {
    window.location.href = to;
  }, [to]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#39a5d3] mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to reviews...</p>
      </div>
    </div>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <FloatingContact />
      <Routes>
        <Route path="/" element={<Home />} />
        
        {/* Company Dropdown Routes */}
        <Route path="/about" element={<About />} />
        <Route path="/team" element={<OurTeam />} />
        <Route path="/what-we-do" element={<WhatWeDo />} />
        <Route 
          path="/reviews" 
          element={<ExternalRedirect to="https://www.google.com/search?sca_esv=896419ed210a4547&rlz=1C1DJPT_en-GB&sxsrf=ANbL-n45zBP_fLlEnK8_JShGrQxkEBI9QA:1770659267211&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qOdY22s05WjbkkT_KK-wgJeK_M92E2redwcNfcxhm05_RuhfR4Vo6e1RmsXiyWc4RMhVkvJRAOCQYLTKgqiEeBs0DZmWcSTUaS1_taHA-Uu-F-_-ghjEFw1mnv6GKe-3UGM-zCs8%3D&q=Docmize+Solutions+Private+Limited+Reviews&sa=X&ved=2ahUKEwjdvY_l-8ySAxVY3jgGHZqILt0Q0bkNegQIJhAH&biw=1366&bih=599&dpr=1" />} 
        />
        <Route path="/hiring" element={<Hiring />} />
        
        {/* Blog Routes */}
        <Route path="/blog" element={<Blog />} />
        
        {/* Existing Blog Detail Pages (3) */}
        <Route path="/blog/local-seo-guide" element={<LocalSEOGuide />} />
        <Route path="/blog/social-media-strategies" element={<SocialMediaStrategies />} />
        <Route path="/blog/google-ads-guide" element={<GoogleAdsGuide />} />
        
        {/* New Blog Detail Pages (9) */}
        <Route path="/blog/seo-content-strategy" element={<SEOContentStrategy />} />
        <Route path="/blog/instagram-marketing-guide" element={<InstagramMarketing />} />
        <Route path="/blog/email-marketing-healthcare" element={<EmailMarketing />} />
        <Route path="/blog/patient-acquisition-strategies" element={<PatientAcquisition />} />
        <Route path="/blog/website-conversion-optimization" element={<WebsiteConversion />} />
        <Route path="/blog/ai-automation-healthcare" element={<AIAutomation />} />
        <Route path="/blog/telemedicine-marketing" element={<TelemedicineMarketing />} />
        <Route path="/blog/medical-website-features" element={<MedicalWebsiteFeatures />} />
        <Route path="/blog/healthcare-content-marketing" element={<HealthcareContentMarketing />} />
      
        {/* Services Routes */}
        <Route path="/services" element={<Services />} />
        <Route path="/services/meta-virtual-assistant" element={<MetaVirtualAssistant />} /> 
        <Route path="/services/growth-visibility" element={<GrowthVisibility />} />
        <Route path="/services/marketing-client-acquisition" element={<MarketingClientAcquisition />} />
        <Route path="/services/digital-platforms-experience" element={<DigitalPlatformsExperience />} />
        <Route path="/services/creative-media-branding" element={<CreativeMediaBranding />} />
        <Route path="/services/social-media-branding" element={<SocialMediaBranding />} />
        <Route path="/services/systems-automation-consulting" element={<SystemsAutomationConsulting />} />
        <Route path="/services/patient-communication-analytics" element={<PatientCommunicationAnalytics />} />
        
        {/* Other Routes */}
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;